export const AUTOSAVED_DRAFT_TYPES = {
  MESSAGE: 'message',
  COMMENT: 'comment',
} as const;
